// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
/* Rubik-Light - latin */
@font-face {
  font-display: swap;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 300;
  src: local('Rubik'), local('Rubik-Light'), url('https://assets.socialtables.com/fonts/Rubik-Light.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-Light.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-Light.ttf') format('truetype');
  /* Safari, Android, iOS */
}
/* Rubik-Regular - latin */
@font-face {
  font-display: swap;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  src: local('Rubik'), local('Rubik-Regular'), url('https://assets.socialtables.com/fonts/Rubik-Regular.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-Regular.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-Regular.ttf') format('truetype');
  /* Safari, Android, iOS */
}
/* Rubik-Medium - latin */
@font-face {
  font-display: swap;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  src: local('Rubik'), local('Rubik-SemiBold'), url('https://assets.socialtables.com/fonts/Rubik-Medium.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-Medium.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-Medium.ttf') format('truetype');
  /* Safari, Android, iOS */
}
/* Rubik-SemiBold - latin */
@font-face {
  font-display: swap;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 600;
  src: local('Rubik'), local('Rubik-Bold'), url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('truetype');
  /* Safari, Android, iOS */
}
/* Rubik-Bold - latin */
@font-face {
  font-display: swap;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 700;
  src: local('Rubik'), local('Rubik-Bold'), url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('truetype');
  /* Safari, Android, iOS */
}
html,
body {
  font-family: 'Rubik', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  min-height: 100vh;
  min-width: 100vw;
}
#earth-portal-app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 100vw;
}
.bold {
  font-weight: 500;
}
.separator {
  display: flex;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 8px;
  color: #69717a;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  /* Base/Regular/1 */
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 18px */
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #000000;
}
.separator:not(:empty)::before {
  margin-right: 1em;
}
.separator:not(:empty)::after {
  margin-left: 1em;
}
.screen-reader-only:not(:focus):not(:active) {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./src/style/index.less","webpack://./reset.less","webpack://./base.less"],"names":[],"mappings":"AAAA;;;CAGC;ACED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;ADAF;AACA,gDAAgD;ACEhD;;;;;;;;;;;EAWE,cAAA;ADAF;ACEA;EACE,cAAA;ADAF;ACEA;;EAEE,gBAAA;ADAF;ACEA;;EAEE,YAAA;ADAF;ACEA;;;;EAIE,WAAA;EACA,aAAA;ADAF;ACEA;EACE,yBAAA;EACA,iBAAA;ADAF;AACA,wBAAwB;AE7HxB;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uUAAA;EF+HA,yBAAyB;AAC3B;AACA,0BAA0B;AEpH1B;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+UAAA;EFsHA,yBAAyB;AAC3B;AACA,yBAAyB;AE1GzB;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6UAAA;EF4GA,yBAAyB;AAC3B;AACA,2BAA2B;AEhG3B;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+UAAA;EFkGA,yBAAyB;AAC3B;AACA,uBAAuB;AEtFvB;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+UAAA;EFwFA,yBAAyB;AAC3B;AE5EA;;EAEE,sDAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AF8EF;AE3EA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AF6EF;AE1EA;EACE,gBAAA;AF4EF;AEzEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,cAAA;EAEA,kBAAA;EACA,6CAAA;EFyEA,mBAAmB;EEpEnB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EFsEA,SAAS;AACX;AEpEA;;EAEE,WAAA;EACA,OAAA;EACA,gCAAA;AFsEF;AEnEA;EACE,iBAAA;AFqEF;AElEA;EACE,gBAAA;AFoEF;AEjEA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AFmEF;AACA,oCAAoC","sourcesContent":["/* http://meyerweb.com/eric/tools/css/reset/ \n   v2.0 | 20110126\n   License: none (public domain)\n*/\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: '';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n/* Rubik-Light - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Rubik'), local('Rubik-Light'), url('https://assets.socialtables.com/fonts/Rubik-Light.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-Light.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-Light.ttf') format('truetype');\n  /* Safari, Android, iOS */\n}\n/* Rubik-Regular - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Rubik'), local('Rubik-Regular'), url('https://assets.socialtables.com/fonts/Rubik-Regular.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-Regular.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-Regular.ttf') format('truetype');\n  /* Safari, Android, iOS */\n}\n/* Rubik-Medium - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  src: local('Rubik'), local('Rubik-SemiBold'), url('https://assets.socialtables.com/fonts/Rubik-Medium.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-Medium.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-Medium.ttf') format('truetype');\n  /* Safari, Android, iOS */\n}\n/* Rubik-SemiBold - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Rubik'), local('Rubik-Bold'), url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('truetype');\n  /* Safari, Android, iOS */\n}\n/* Rubik-Bold - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Rubik'), local('Rubik-Bold'), url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('woff2'), /* Super Modern Browsers*/ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.woff') format('woff'), /* Modern Browsers */ url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf') format('truetype');\n  /* Safari, Android, iOS */\n}\nhtml,\nbody {\n  font-family: 'Rubik', 'Helvetica', 'Arial', sans-serif;\n  font-weight: 400;\n  min-height: 100vh;\n  min-width: 100vw;\n}\n#earth-portal-app {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  min-width: 100vw;\n}\n.bold {\n  font-weight: 500;\n}\n.separator {\n  display: flex;\n  align-items: center;\n  margin-top: 32px;\n  margin-bottom: 8px;\n  color: #69717a;\n  text-align: center;\n  font-feature-settings: 'clig' off, 'liga' off;\n  /* Base/Regular/1 */\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  /* 18px */\n}\n.separator::before,\n.separator::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid #000000;\n}\n.separator:not(:empty)::before {\n  margin-right: 1em;\n}\n.separator:not(:empty)::after {\n  margin-left: 1em;\n}\n.screen-reader-only:not(:focus):not(:active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n/*# sourceMappingURL=index.css.map */","/* http://meyerweb.com/eric/tools/css/reset/ \n   v2.0 | 20110126\n   License: none (public domain)\n*/\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: '';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n","/* Rubik-Light - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 300;\n  src:\n    local('Rubik'),\n    local('Rubik-Light'),\n    url('https://assets.socialtables.com/fonts/Rubik-Light.ttf') format('woff2'),\n    /* Super Modern Browsers*/\n      url('https://assets.socialtables.com/fonts/Rubik-Light.woff')\n      format('woff'),\n    /* Modern Browsers */\n      url('https://assets.socialtables.com/fonts/Rubik-Light.ttf')\n      format('truetype'); /* Safari, Android, iOS */\n}\n\n/* Rubik-Regular - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  src:\n    local('Rubik'),\n    local('Rubik-Regular'),\n    url('https://assets.socialtables.com/fonts/Rubik-Regular.ttf')\n      format('woff2'),\n    /* Super Modern Browsers*/\n      url('https://assets.socialtables.com/fonts/Rubik-Regular.woff')\n      format('woff'),\n    /* Modern Browsers */\n      url('https://assets.socialtables.com/fonts/Rubik-Regular.ttf')\n      format('truetype'); /* Safari, Android, iOS */\n}\n\n/* Rubik-Medium - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  src:\n    local('Rubik'),\n    local('Rubik-SemiBold'),\n    url('https://assets.socialtables.com/fonts/Rubik-Medium.ttf')\n      format('woff2'),\n    /* Super Modern Browsers*/\n      url('https://assets.socialtables.com/fonts/Rubik-Medium.woff')\n      format('woff'),\n    /* Modern Browsers */\n      url('https://assets.socialtables.com/fonts/Rubik-Medium.ttf')\n      format('truetype'); /* Safari, Android, iOS */\n}\n\n/* Rubik-SemiBold - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 600;\n  src:\n    local('Rubik'),\n    local('Rubik-Bold'),\n    url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf')\n      format('woff2'),\n    /* Super Modern Browsers*/\n      url('https://assets.socialtables.com/fonts/Rubik-SemiBold.woff')\n      format('woff'),\n    /* Modern Browsers */\n      url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf')\n      format('truetype'); /* Safari, Android, iOS */\n}\n\n/* Rubik-Bold - latin */\n@font-face {\n  font-display: swap;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 700;\n  src:\n    local('Rubik'),\n    local('Rubik-Bold'),\n    url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf')\n      format('woff2'),\n    /* Super Modern Browsers*/\n      url('https://assets.socialtables.com/fonts/Rubik-SemiBold.woff')\n      format('woff'),\n    /* Modern Browsers */\n      url('https://assets.socialtables.com/fonts/Rubik-SemiBold.ttf')\n      format('truetype'); /* Safari, Android, iOS */\n}\n\nhtml,\nbody {\n  font-family: 'Rubik', 'Helvetica', 'Arial', sans-serif;\n  font-weight: 400;\n  min-height: 100vh;\n  min-width: 100vw;\n}\n\n#earth-portal-app {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  min-width: 100vw;\n}\n\n.bold {\n  font-weight: 500;\n}\n\n.separator {\n  display: flex;\n  align-items: center;\n  margin-top: 32px;\n  margin-bottom: 8px;\n  text-align: center;\n  color: @TextIconInteractive-soft;\n\n  text-align: center;\n  font-feature-settings:\n    'clig' off,\n    'liga' off;\n\n  /* Base/Regular/1 */\n  font-family: Rubik;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 18px */\n}\n\n.separator::before,\n.separator::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid @TextIconInteractive-warning;\n}\n\n.separator:not(:empty)::before {\n  margin-right: 1em;\n}\n\n.separator:not(:empty)::after {\n  margin-left: 1em;\n}\n\n.screen-reader-only:not(:focus):not(:active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n@headerHeight: 80px;\n@footerHeight: 40px;\n@spaceAboveTitle: 3%;\n@mobilePlanBannerHeight: 60px;\n\n@--carina-box-shadow-lg:\n  0 10px 15px -3px rgb(0 0 0 / 0.1),\n  0 4px 6px -4px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
